import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BookedCourtListType } from "../../../utilities/types";
import { GetAssociateBookingList } from "../../../utilities/api/associateBooking";
import { messages } from "../../../utilities/Messages";

type ErrorMessageType = {
    message: string;
}

const initialState = {
    currentPage: 0,
    rowsPerPage: 0,
    totalPage: 0,
    totalRows: 0,
    error: {} as ErrorMessageType,
    AllAssociateBooking: [] as BookedCourtListType[],
    associateColumns: [
        {
            Header: 'Customer Name',
            accessor: 'fullName',
        },
        {
            Header: 'Contact Number',
            accessor: 'phone',
        },
        {
            Header: 'Associate Name',
            accessor: 'companyName',
        },
        {
            Header: 'Booking Date',
            accessor: 'bookingDate',
        },
        {
            Header: 'Start Date',
            accessor: 'startDate',
        },
        {
            Header: 'End Date',
            accessor: 'endDate',
        },
        {
            Header: 'Booking Status',
            accessor: 'status',
        },
        {
            Header: 'Payment Status',
            accessor: 'paymentStatus',
        },
    ]
}

export const AllAssociateBookingList = createAsyncThunk("BookedAssociateList/AllBookedCourtsList", (data: any) => GetAssociateBookingList(data))

const AssociateBookingListSlice = createSlice({
    name: "BookedAssociateList",
    initialState,
    reducers: {
        setAssociateColumn: (state: any, action: any) => {
            state.associateColumns = action.payload
        }
    },
    extraReducers: (builder) => {
        builder

            .addCase(AllAssociateBookingList.fulfilled, (state, action: PayloadAction<any>) => {
                if (action.payload.statusCode === 200) {
                    let data = action.payload.data
                    state.rowsPerPage = data.limit
                    state.currentPage = data.page
                    state.totalPage = data.totalPages
                    state.totalRows = data.totalRows

                    state.AllAssociateBooking = data.rows.map((item: any) => (
                        {
                            id: item.id,
                            fullName: item.user.firstName + " " + item.user.lastName,
                            phone: item.user.phone,
                            bookingType: item.bookingType,
                            companyName: item.companyName ? item.companyName : "-",
                            bookingDate: item.createdAt,
                            status: item.status,
                            sportName: item.sportName,
                            totalAmount: Math.round(item.totalAmount),
                            paymentMode: item.paymentMode,
                            paymentMethod: item.paymentMethod ? item.paymentMethod : "-",
                            paymentStatus: item.paymentStatus,
                            facilityName: item.facilityName,
                            startDate: item.startDate,
                            endDate: item.endDate
                        }
                    ))
                }
            })
            .addCase(AllAssociateBookingList.rejected, (state, action) => {
                state.error = { message: messages.error.internal_server_error };
            });

    }
})

export default AssociateBookingListSlice.reducer
export const { setAssociateColumn } = AssociateBookingListSlice.actions
